import logo from './images/cuck.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Get cucked. IYKYK.
        </p>
      </header>
    </div>
  );
}

export default App;
